import React from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Typography, Divider, Button } from "antd";
import {
  FileExclamationOutlined,
  PieChartOutlined,
  MailOutlined,
  BarcodeOutlined,
} from "@ant-design/icons";

const { Text, Title } = Typography;

function MenuCancelContract({ onClick }) {
  const navigate = useNavigate();
  const ROLE_ID = localStorage.getItem("ROLE_ID");

  const handleMenuClick = (item) => {
    if (onClick) onClick(item.label); // ส่งชื่อไปที่ Header
    navigate(item.path);
  };

  const menuGroups = [
    {
      groupTitle: "บอกเลิกสัญญา",
      show: ROLE_ID === "1" || ROLE_ID === "2",
      items: [
        {
          icon: <FileExclamationOutlined />,
          label: "บอกเลิกสัญญา > ออกบอกเลิกสัญญา",
          path: "/cancel-contract/create-cancel-Contract",
          show: true,
        },
        {
          icon: <MailOutlined />,
          label: "บอกเลิกสัญญา > นำเข้าเลขไปษณีย์",
          path: "/cancel-contract/update-parcel-number",
          show: true,
        },
        {
          icon: <BarcodeOutlined />,
          label: "บอกเลิกสัญญา > นำเข้าตอบกลับ",
          path: "/cancel-contract/update-status-response",
          show: true,
        },
        {
          icon: <PieChartOutlined />,
          label: "บอกเลิกสัญญา > รายงานตอบกลับ",
          path: "/cancel-contract/report-response",
          show: true,
        },
      ],
    },
  ];

  return (
    <div className="dashboard-wrapper">
      {/* <Button
        type="primary"
        ghost
        icon={<RollbackOutlined />}
        onClick={() => {
          if (onClick) onClick("หน้าแรก");
          navigate("/");
        }}
        style={{ marginBottom: 16 }}
      >
        ย้อนกลับ
      </Button> */}
      {menuGroups.map(
        (group, gIndex) =>
          group.show && (
            <div key={gIndex}>
              <Divider orientation="left">
                <Title level={4}>{group.groupTitle}</Title>
              </Divider>
              <Row gutter={[24, 24]}>
                {group.items.map(
                  (item, index) =>
                    item.show && (
                      <Col xs={12} sm={8} md={6} lg={4} key={index}>
                        <div
                          className="menu-card"
                          onClick={() => handleMenuClick(item)}
                        >
                          <div className="icon-wrapper">{item.icon}</div>
                          <Text className="menu-text-gold">
                            {
                              item.label.includes(">")
                                ? item.label.split(">")[1] // ถ้ามี '>' ให้เอาตัวหลังสุดมาโชว์
                                : item.label // ถ้าไม่มีให้โชว์ปกติ
                            }
                          </Text>
                        </div>
                      </Col>
                    )
                )}
              </Row>
            </div>
          )
      )}
    </div>
  );
}

export default MenuCancelContract;
